import React, { Component } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// ui/ux
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// ours
import GroupTable from '../../GroupTable';
import Waiting from '../../../Waiting';
import ErrorSign from '../../../ErrorSign';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST;

const styles = (theme) => ({
  input: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    }
  },
  filterField: {
    float: 'right',
    width: '30vw'
  },
  selBox: {
    border: `1px dashed ${theme.palette.primary.main}`,
    minHeight: 100,
    margin: `${theme.spacing(2)}px 0px ${theme.spacing(2)}px 0px`,
    padding: theme.spacing(2)
  },
  hintBox: {
    '& > h2': {
      lineHeight: '100px'
    },
    textAlign: 'center',
    color: theme.palette.primary.main
  }
});

class SelectScopes extends Component {
  constructor(props) {
    super(props);
    console.log('SelectScopes', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    this.state = {
      filterText: null,
      selectedScopes: []
    };
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onScopeSelect = this.onScopeSelect.bind(this);
    this.onScopeClear = this.onScopeClear.bind(this);
    this.cbEnterKey = this.enterKey.bind(this);

    this._xhrScopesSlim = {};
    this._xhrScopes = {};
  }
  enterKey() {
    const { selectedScopes } = this.state;
    if (selectedScopes.length > 0) {
      this.props.onComplete(selectedScopes);
    }
  }
  componentWillUnmount() {
    this._xhrScopesSlim.cancel && this._xhrScopesSlim.cancel();
    this._xhrScopes.cancel && this._xhrScopes.cancel();
    window.removeEventListener('keyup', this.cbEnterKey);
  }
  componentDidMount() {
    window.addEventListener('keyup', this.cbEnterKey);
    this._xhrScopesSlim.cancel && this._xhrScopesSlim.cancel();
    window.genericGet(`${API_HOST}/admin/v0/scopes/all/slim`, this._xhrScopesSlim, (e, r) => {
      if (e) {
        console.error(e);
        return this.setState({
          xhrFailed: true
        });
      }

      this.setState({
        scopes: r.filter((d) => d.scope_id !== '-1')
      });

      this._xhrScopes.cancel && this._xhrScopes.cancel();
      window.genericGet(`${API_HOST}/admin/v0/scopes/all`, this._xhrScopes, (e, r1) => {
        if (e) return;
        this.setState({
          scopes: r1.filter((d) => d.scope_id !== '-1')
        });
      });
    });
  }
  onFilterChange(e) {
    const v = e.target.value;
    this.setState({
      filterText: v
    });
  }
  onScopeSelect(scope) {
    this.setState({
      selectedScopes: [...this.state.selectedScopes, scope]
    });
  }
  onScopeClear(scope) {
    const { selectedScopes } = this.state;
    const i = selectedScopes.indexOf(scope);
    this.setState({
      selectedScopes: [...selectedScopes.slice(0, i), ...selectedScopes.slice(i + 1)]
    });
  }
  renderButtons() {
    const { selectedScopes } = this.state;
    const { onComplete } = this.props;
    return (
      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <Button
            disabled={selectedScopes.length === 0}
            variant="outlined"
            color="secondary"
            onClick={() => {
              onComplete(selectedScopes);
            }}
          >
            Next
          </Button>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const { scopes, selectedScopes, filterText, xhrFailed } = this.state;
    if (xhrFailed) {
      return <ErrorSign height="300px" />;
    }
    if (!scopes) {
      return <Waiting height="300px" />;
    }
    const availableScopes = scopes.filter((d) => selectedScopes.indexOf(d) === -1);
    return (
      <React.Fragment>
        <Typography>Select user groups this form data should be made available to -</Typography>
        {this.renderButtons()}
        <Box className={clsx(classes.selBox, selectedScopes.length === 0 && classes.hintBox)}>
          {selectedScopes.length > 0 ? (
            selectedScopes.map((d) => <Chip onClick={() => this.onScopeClear(d)} key={d.scope_id} label={d.name} onDelete={() => this.onScopeClear(d)} color="primary" />)
          ) : (
            <Typography variant="h2">Selected User Groups</Typography>
          )}
        </Box>
        <TextField className={clsx(classes.filterField, classes.input)} label="Filter Scopes" variant="outlined" onChange={this.onFilterChange} />
        <GroupTable scopes={availableScopes} onGroupSelect={this.onScopeSelect} filterText={filterText} />
        {this.renderButtons()}
      </React.Fragment>
    );
  }
}

SelectScopes.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  onComplete: PropTypes.func.isRequired
};

SelectScopes.defaultProps = {};

export default withTheme(withStyles(styles)(SelectScopes));
